import * as size from './size.js'
import { fontDefault } from './preload.js'
import * as buttonText from './ui-button-text.js'
import * as fade from './ui-fade.js'

export default async function procTitle(params) {
    const { app, w, h, cards } = params;
    let title, subtitle, cardBack, cardFront, button;

    // Title
    const rate = size.rateX();
    const style = {
        fontFamily: fontDefault, fontSize: 90 * rate, fill: 'white',
        stroke: { color: 'black', width: 4 * rate, join: 'round' },
        dropShadow: { color: 'black', blur: 5 * rate, distance: 2 * rate,
            angle: Math.PI * 0.33 }
    };
    title = new PIXI.Text({ text: 'TAROT', style });
    title.anchor = 0.5;
    title.x = w / 2;
    title.y = h * 0.1;
    title.zIndex = 100;
    app.stage.addChild(title);

    style.fontSize = 75 * size.rateX()
    subtitle = new PIXI.Text({ text: 'DIAMOND CROSS', style });
    subtitle.anchor = 0.5;
    subtitle.x = w / 2;
    subtitle.y = h * 0.23;
    subtitle.zIndex = 100;
    app.stage.addChild(subtitle);

    // Card
    for (let i = 0; i < 2; i ++) {
        const card = new PIXI.Sprite(cards[i].__front);
        card.__time = 1000;
        card.__index = 0;
        card.x = w / 2;
        card.y = h / 2;
        card.anchor.x = 0.5;
        card.anchor.y = 0.5;
        card.scale = 1 * size.rateX();
        card.zIndex = - i;
        app.stage.addChild(card);

        if (i === 0) cardFront = card;
        if (i === 1) cardBack = card;
    }

    // Animate card
    anime({
        targets: [cardBack, cardFront],
        rotation: Math.PI * 2, easing: 'linear', duration: 8000, loop: true
    });

    anime.timeline({
        loop: true,
        loopComplete: anim => {
            cardFront.alpha = 1;
            cardFront.texture = cardBack.texture;
            cardBack.__index = (cardBack.__index + 1) % cards.length;
            cardBack.texture = cards[cardBack.__index].__front;
        }
    })
    .add({ duration: 1500 })
    .add({ targets: cardFront, alpha: 0, easing: 'linear', duration: 500 });

    // Button
    const text = '占いをおこなう';
    await new Promise(resolve => {
        button = buttonText.gen(app, text, async () => {
            await fade.fadeOut(app);
            title.destroy();
            subtitle.destroy();
            cardBack.destroy();
            cardFront.destroy();
            button.destroy();
            resolve();
        });
        button.y = h * 0.9;
        button.zIndex = 100;
    });
};
